module.exports = "<div ng-transclude=\"title\" class=\"display-info__title\"></div> <div ng-transclude=\"verified\" class=\"display-info__verified\"></div> <div ng-transclude=\"content\" class=\"display-info__content\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/displayInfo/displayInfo.html
// module id = 785
// module chunks = 0